<template>
	<section id="theme_search_form" style="position: absolute-center; z-index: 2">
		<div class="container">
			<div class="row">
				<div class="col-lg-12">
					<div class="theme_search_form_area">
						<div class="row">
							<div class="col-lg-12">
								<div class="tour_search_form">
									<form @submit.prevent="propertiesSearch">
										<div class="row">
											<!-- DESTINATION -->
											<div class="col-lg-4 col-md-6 px-0 px-md-1 px-lg-1 col-sm-12">
												<div class="form_search_date">
													<div class="flight_Search_boxed py-3"
														:class="{ 'has-error': !!errors.destination }">
														<p>{{ $t('destination') }}</p>
														<v-select v-model="selectedOption" label="text"
															:options="filteredOptions" :filterable="true"
															:placeholder="$t('where_do_you_want_to_go')"
															@search="handleSearch" @input="updateSelectedOptionId">
															<template #no-options="{ search }">
																<span v-if="search.length <= 2">{{
																	$t('Please_enter_least_2_characters') }}</span>
																<span v-else>{{ $t('no_results_found') }}</span>
															</template>
														</v-select>
														<small v-if="errors.destination" class="error-text">{{
															errors.destination }}</small>
													</div>
												</div>

											</div>

											<!-- DATES -->
											<div class="col-lg-4 col-md-6 px-0 px-md-1 px-lg-1 col-sm-12 ">
												<div class="form_search_date w-100"
													>
													<div class="flight_Search_boxed w-100 pt-3 pb-4 date_flex_area" :class="{ 'has-error': !!errors.dates }">
														<div class="Journey_date w-100">
															<p>{{ $t('dates_of_stay') }}</p>
															<flat-pickr v-model="selectedDates" :config="dateConfig"
																:placeholder="$t('entry_date') + ' - ' + $t('departure_date')"
																class="w-100" @onChange="handleDateChange" />
															<div v-if="errors.dates" class="error-text w-100">{{
																errors.dates
																}}</div>
														</div>

													</div>

												</div>
											</div>

											<!-- GUESTS + NATIONALITY -->
											<div class="col-lg-2 col-md-6 px-0 px-md-1 px-lg-1 col-sm-12 ">
												<div class="form_search_date">
													<div class="flight_Search_boxed py-3 date_flex_area"
														:class="{ 'has-error': !!errors.guests || !!errors.nationality }">
														<CountDropdownHotel :props_nationality="props_nationality"
															:props_guests="props_guests"
															@updateGuests="handleUpdateGuests"
															@updatecustomerNationality="setcustomerNationality"
															:errors="errors" />
													</div>
												</div>
											</div>

											<!-- SEARCH BUTTON -->
											<div class="col-lg-2 col-md-6 px-0 px-md-1 px-lg-1 col-sm-12 ">
												<div @click="propertiesSearch" :class="[
													'btn',
													'search',
													'btn_theme',
													'd-flex',
													'align-items-center',
													'justify-content-center',
													'flight_Search_boxed',
													{ disabled: isLoading },
												]" :disabled="isLoading">
													{{ $t('search') }}
													<i v-if="!isLoading" class="px-2 fas fa-angle-right text-coral"></i>
													<div v-else class="loader"></div>
												</div>
											</div>

										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
/* All code comments are in English as requested. */
import CountDropdownHotel from "@/components/home/CountDropdownHotel.vue";
import Swal from "sweetalert2";
import axios from "axios";
import { mapState, mapActions } from "vuex";
import { API_BASE_URL, COUNTRY_STATE_CITY_API } from "@/api-config";
import FlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es.js";

export default {
	name: "Form",
	components: {
		CountDropdownHotel,
		FlatPickr,
	},
	props: {
		props_destiny: { type: Object, default: null },
		props_guests: { type: Array, default: null },
		props_nationality: String,
		props_start_date: Date,
		props_end_date: Date,
		props_adults: Number,
		props_children: Array,
		props_city: String,
		props_country: String,
		props_rooms: Number,
	},
	data() {
		return {
			destination: "",
			active: false,
			searchText: "",
			results: { cities: [], countries: [], properties: [], allOptions: [] },
			start_date: "",
			end_date: "",
			selectedOption: "",
			city: "",
			country: "",
			national: {},
			guests: [],
			isLoading: false,
			selectedDates: [],
			errors: {
				destination: "",
				dates: "",
				guests: "",
				nationality: "",
			},
			dateConfig: {
				locale: Spanish,
				mode: "range",
				showMonths: 1,
				dateFormat: "Y-m-d",
				minDate: "today",
				defaultDate: this.selectedDates, // Example: ["2025-07-26","2025-07-27"]
			},
		};
	},
	watch: {
		/* Hydrate dates if props are provided (SSR or link-in) */
		props_start_date: {
			immediate: true,
			handler(newVal) {
				if (newVal) {
					const [y, m, d] = newVal.split("-");
					this.selectedDates[0] = new Date(+y, +m - 1, +d);
					this.start_date = `${y}-${m}-${d}`;
				}
			},
		},
		props_end_date: {
			immediate: true,
			handler(newVal) {
				if (newVal) {
					const [y, m, d] = newVal.split("-");
					this.selectedDates[1] = new Date(+y, +m - 1, +d);
					this.end_date = `${y}-${m}-${d}`;
				}
			},
		},
	},
	mounted() {
		this.getCountryStateCity();

		// Initialize date range with today → (optional) end date
		const today = new Date();
		const propsStartDate = this.props_start_date ? new Date(this.props_start_date) : null;
		const propsEndDate = this.props_end_date ? new Date(this.props_end_date) : null;

		if (propsStartDate && propsStartDate >= today) {
			this.selectedDates[0] = propsStartDate;
			this.start_date = propsStartDate.toISOString().slice(0, 10);
		} else {
			this.selectedDates[0] = today;
			this.start_date = today.toISOString().slice(0, 10);
		}

		if (propsEndDate && propsEndDate > this.selectedDates[0]) {
			this.selectedDates[1] = propsEndDate;
			this.end_date = propsEndDate.toISOString().slice(0, 10);
		}

		// Optional prefill
		this.city = this.props_city;
		this.country = this.props_country;
		this.rooms = this.props_rooms;

		if (this.props_destiny != null) {
			this.selectedOption = this.props_destiny;
		}
	},

	computed: {
		...mapState({
			adults: (state) => state.form.adults,
			children: (state) => state.form.children,
			guestsStore: (state) => state.form.guests,
			cityStore: (state) => state.form.city,
			countryStore: (state) => state.form.country,
			customerNationality: (state) => state.form.customerNationality,
			error: (state) => state.form.error,
		}),
		/* Client-side filter for the async-loaded options */
		filteredOptions() {
			if (!this.searchText || this.searchText.length < 2) return [];
			return this.results.allOptions.filter((option) =>
				option.text.toLowerCase().includes(this.searchText.toLowerCase())
			);
		},
	},

	methods: {
		...mapActions("form", ["updateGuests", "fetchProperties", "updateError"]),

		handleUpdateGuests(guestData) {
			// Keep local copy for validation and serialization
			this.guests = guestData;
		},

		handleDateChange(selectedDates) {
			// Normalize to Y-m-d
			if (selectedDates.length === 2) {
				const formatDate = (date) => {
					const d = new Date(date);
					const year = d.getFullYear();
					const month = String(d.getMonth() + 1).padStart(2, "0");
					const day = String(d.getDate()).padStart(2, "0");
					return `${year}-${month}-${day}`;
				};
				this.start_date = formatDate(selectedDates[0]);
				this.end_date = formatDate(selectedDates[1]);
			}
		},

		setcustomerNationality(customerNationality) {
			this.national = customerNationality;
		},

		showAlert(message, type) {
			Swal.fire({
				icon: type,
				title: type === "success" ? this.$t("success_title") : this.$t("error_title"),
				html: message, // allow HTML list
			}).then(() => {
				this.updateError({ status: false, message: "" });
			});
		},

		resetErrors() {
			this.errors = { destination: "", dates: "", guests: "", nationality: "" };
		},

		/* Validate all required inputs before searching */
		validateForm() {
			// Destination
			if (!this.selectedOption) {
				this.errors.destination = this.$t("destination_required");
			}

			// Dates
			if (!this.start_date || !this.end_date) {
				this.errors.dates = this.$t("dates_required");
			} else {
				const s = new Date(this.start_date);
				const e = new Date(this.end_date);
				if (!(e > s)) {
					this.errors.dates = this.$t("dates_invalid_range");
				}
			}

			// Guests
			if (!Array.isArray(this.guests) || this.guests.length === 0) {
				this.errors.guests = this.$t("guests_required");
			} else {
				const invalidIdx = this.guests.findIndex((g) => {
					const hasAdults = Number.isInteger(+g?.adults) && +g.adults >= 1;
					const validChildrenArr =
						Array.isArray(g?.children) && g.children.every((c) => Number.isFinite(+c) && +c >= 0);
					return !hasAdults || !validChildrenArr;
				});
				if (invalidIdx !== -1) {
					this.errors.guests = this.$t("guests_invalid_room", { room: invalidIdx + 1 });
				}
			}

			// Nationality
			if (!this.national || !this.national.slug) {
				this.errors.nationality = this.$t("nationality_required");
			}

			// Return true if no errors
			return Object.values(this.errors).every((v) => !v);
		},

		getCountryStateCity() {
			axios
				.get(`${API_BASE_URL}${COUNTRY_STATE_CITY_API}`)
				.then((response) => {
					this.results.cities = response.data.cities.map((city) => ({
						...city,
						city_id: city.city_id,
					}));
					// If your API returns countries, you can uncomment the next line:
					// this.results.countries = response.data.countries || [];
					this.results.properties = response.data.properties || [];
					this.results.allOptions = [
						...this.results.cities,
						// ...this.results.countries, // add countries if you enabled them above
						...this.results.properties,
					];
				})
				.catch((error) => {
					console.log(error);
				});
		},

		handleSearch(searchTerm) {
			this.searchText = searchTerm;
		},

		updateSelectedOptionId(selectedOption) {
			if (selectedOption && selectedOption.id) {
				this.selectedOptionId = selectedOption.id;
				this.destination = selectedOption.text;
			} else {
				this.selectedOptionId = null;
				this.destination = "";
			}
		},

		serializeGuests(guestsArray) {
			// Produces: "adults=[2],children=[5,8]&adults=[1],children=[]"
			return guestsArray
				.map((g) => `adults=[${g.adults}],children=[${(g.children || []).join(",")}]`)
				.join("&");
		},

		async propertiesSearch() {
			this.isLoading = true;
			this.resetErrors();

			// 1) Block if invalid
			const isValid = this.validateForm();
			if (!isValid) {
				this.isLoading = false;
				const list = Object.values(this.errors)
					.filter(Boolean)
					.map((e) => `<li>${e}</li>`)
					.join("");
				this.showAlert(`<ul style="text-align:left;margin:0 0 0 1rem;">${list}</ul>`, "error");
				return;
			}

			// 2) Build query
			let queryParameters = {
				start_date: this.start_date,
				end_date: this.end_date,
				rooms: 0,
				city: this.city,
				country: this.country,
				customerNationality: this.national.slug,
				guests: this.guests,
			};
			queryParameters.rooms = queryParameters.guests.length;
			const serializedGuests = this.serializeGuests(queryParameters.guests);

			// 3) Route by option type
			try {
				if (this.selectedOption) {
					const optionTypes = ["cities", "countries", "properties"];
					const optionType = optionTypes.find((type) =>
						(this.results[type] || []).some((item) => item.id === this.selectedOption.id)
					);

					if (optionType === "cities") {
						const selectedOptionId = this.selectedOption.id;
						const [cityPart, countryPart] = selectedOptionId.split("*#");
						queryParameters.city = cityPart ? cityPart.split("=")[1] : "";
						queryParameters.country = countryPart ? countryPart.split("=")[1] : "";

						const cityId = this.selectedOption.city_id;

						await this.fetchProperties(queryParameters);

						if (this.error.status === true) {
							this.showAlert(this.error.message, "error");
						} else {
							let queryParams = {
								start_date: this.start_date,
								end_date: this.end_date,
								rooms: queryParameters.rooms,
								city: queryParameters.city,
								country: queryParameters.country,
								customerNationality: this.national.slug,
								guests: serializedGuests,
								destiny_id: this.selectedOption.id,
								destiny_slug: this.selectedOption.slug,
								destiny_text: this.selectedOption.text,
								city_id: cityId,
								dd: Date.now().toString(36),
							};
							this.$router.push({ name: "hotel-search", query: queryParams });
						}
					}

					if (optionType === "countries") {
						const selectedOptionId = this.selectedOption.id;
						const [countryPart] = selectedOptionId.split("*#");
						queryParameters.country = countryPart ? countryPart.split("=")[1] : "";

						await this.fetchProperties(queryParameters);

						if (this.error.status === true) {
							this.showAlert(this.error.message, "error");
						} else {
							let queryParams = {
								start_date: this.start_date,
								end_date: this.end_date,
								rooms: queryParameters.rooms,
								country: queryParameters.country,
								customerNationality: this.national.slug,
								guests: serializedGuests,
								destiny_id: this.selectedOption.id,
								destiny_slug: this.selectedOption.slug,
								destiny_text: this.selectedOption.text,
								dd: Date.now().toString(36),
							};
							this.$router.push({ name: "hotel-search", query: queryParams });
						}
					}

					if (optionType === "properties") {
						const selectedOptionId = this.selectedOption.id;
						queryParameters.property_id = selectedOptionId;
						queryParameters.key = this.selectedOption.slug;

						let queryParams = {
							start_date: this.start_date,
							end_date: this.end_date,
							rooms: queryParameters.rooms,
							guests: serializedGuests,
							customerNationality: this.national.slug,
							dd: Date.now().toString(36),
						};

						// Stop spinner before routing
						this.isLoading = false;

						this.$router.push({
							name: "hotel-details",
							params: { key: queryParameters.key, id: selectedOptionId },
							query: queryParams,
						});
						return; // avoid finally switching spinner again
					}
				}
			} catch (error) {
				console.error("Error fetching properties:", error);
				this.showAlert(this.$t("generic_fetch_error"), "error");
			} finally {
				this.isLoading = false;
			}
		},
	},
};
</script>

<style>
/* Prevent month number arrows in flatpickr header */
.flatpickr-current-month .numInputWrapper input[type="number"] {
	pointer-events: none;
}

.flatpickr-current-month .numInputWrapper .arrowUp,
.flatpickr-current-month .numInputWrapper .arrowDown {
	display: none;
}

/* Loader spinner */
.loader {
	border: 4px solid #f3f3f3;
	border-top: 4px solid #3498db;
	border-radius: 50%;
	width: 24px;
	height: 24px;
	animation: spin 1s linear infinite;
	margin: auto;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}

/* Validation styles */
.has-error .vs__dropdown-toggle {
	border-color: #dc3545 !important;
}

/* vue-select input border */
.has-error .flatpickr-input {
	border-color: #dc3545 !important;
}

.has-error.flight_Search_boxed {
	border: 1px solid #dc3545 !important;
	border-radius: 6px;
}

.error-text {
	display: block;
	margin-top: 4px;
	font-size: 0.8rem;
	color: #dc3545;
}
</style>
